import React from "react";
import { useSelector } from "react-redux";
import * as consts from "./const";
import GenericTransitionModal from "../GenericTransitionModal";

const VendorClaimsGenericSuccessModal = () => {
/* eslint-disable no-unused-vars */
const { type, data } = useSelector(
    (state) =>
      state.claimDetailsVendor.activeConfirmModalOptions
  );

/* eslint-enable no-unused-vars */

  const actionMap = {
    "cancel-sale": consts.CANCEL_SALE,
    "request-information": consts.REQUEST_INFORMATION,
    "decline-claim": consts.DECLINE_CLAIM,
    "review-complete": consts.REVIEW_COMPLETE,
    "make-offer": consts.MAKE_OFFER,
    "callback-request": consts.CALLBACK_REQUEST,
    "complete-claim": consts.COMPLETE_CLAIM,
  };

  const getActionMap = (action) => actionMap[action] || {};

  const getText = (action) => {
    const text = getActionMap(action) 
    
    return {
      headerText: text?.headerText ?? "Process Complete",
      bodyText: text?.bodyText ?? "The process has been completed.",
    };
  };

  const { headerText, bodyText } = getText(data?.action);

  return headerText ? (
    <div>
      <GenericTransitionModal headerText={headerText} bodyText={bodyText} />
    </div>
  ) : null;
};

export default VendorClaimsGenericSuccessModal;
